function initOurStory(root) {
  if (!root || root.dataset.storyInit) return;
  root.dataset.storyInit = 'true';

  var modal = document.getElementById('our-story-modal');
  var openBtn = root.querySelector('[data-open-story-modal]');
  var closeBtn = modal ? modal.querySelector('[data-close-story-modal]') : null;

  // Scroll pop-in for the section (story columns + crew grid)
  var sectionTargets = root.querySelectorAll('.fade-in-up');
  observeFadeIns(sectionTargets);


  // Flight path decor
  var inner = modal ? modal.querySelector('.our-story__modal-inner') : null;
  var decor = modal ? modal.querySelector('[data-story-decor]') : null;
  var pathSvg = modal ? modal.querySelector('.our-story__modal-path') : null;
  var pathLine = modal ? modal.querySelector('[data-story-path-line]') : null;
  var plane = modal ? modal.querySelector('[data-story-plane]') : null;

  function topWithin(el) {
    return el.getBoundingClientRect().top - inner.getBoundingClientRect().top + inner.scrollTop;
  }

  function buildPath() {
    if (!inner || !decor || !pathSvg || !pathLine) return;
    var w = decor.clientWidth;
    var h = inner.scrollHeight;
    var rightX = w * 0.96;
    var leftX = w * 0.04;

    var pts = [];

    // Entry: right edge, just below the last intro paragraph (or 15% down)
    var paragraphs = inner.querySelectorAll('.our-story__modal-paragraph');
    var startY = h * 0.15;
    if (paragraphs.length) {
      var lastPara = paragraphs[paragraphs.length - 1];
      startY = topWithin(lastPara) + lastPara.offsetHeight + 30;
    }
    pts.push([w + 15, startY]);
    pts.push([rightX, startY + 50]);

    // One waypoint pair per team photo, in the gutter OPPOSITE the photo,
    // pinned for the photo's full height so the plane never crosses it.
    var photos = inner.querySelectorAll('.our-story__modal-team-photo-wrap');
    photos.forEach(function (photo) {
      var rect = photo.getBoundingClientRect();
      var innerRect = inner.getBoundingClientRect();
      var photoCenterX = rect.left - innerRect.left + rect.width / 2;
      var gutterX = photoCenterX < w / 2 ? rightX : leftX;
      var top = topWithin(photo);
      pts.push([gutterX, top - 25]);
      pts.push([gutterX, top + photo.offsetHeight + 25]);
    });

    // Exit: off the left edge, above the CTA block (or near the bottom)
    var cta = inner.querySelector('.our-story__modal-ctas');
    var endY = cta ? topWithin(cta) - 40 : h - 80;
    pts.push([leftX, Math.max(endY - 60, startY + 100)]);
    pts.push([-15, endY]);

    // Smooth curve through the waypoints
    var d = 'M ' + pts[0][0] + ' ' + pts[0][1];
    for (var i = 1; i < pts.length; i++) {
      var prev = pts[i - 1];
      var curr = pts[i];
      var cx = (prev[0] + curr[0]) / 2;
      d += ' C ' + cx + ' ' + prev[1] + ', ' + cx + ' ' + curr[1] + ', ' + curr[0] + ' ' + curr[1];
    }

    pathSvg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    pathLine.setAttribute('d', d);
  }

  function updateFlight() {
    if (!inner || !decor || !pathLine || !plane) return;
    var maxScroll = inner.scrollHeight - inner.clientHeight;
    var progress = maxScroll > 0 ? inner.scrollTop / maxScroll : 0;
    var total = pathLine.getTotalLength();
    if (!total) return;
    var pt = pathLine.getPointAtLength(progress * total);
    var pt2 = pathLine.getPointAtLength(Math.min(total, progress * total + 2));
    var angle = Math.atan2(pt2.y - pt.y, pt2.x - pt.x) * 180 / Math.PI;
    plane.style.transform = 'translate(' + (pt.x - 13) + 'px, ' + (pt.y - 13) + 'px) rotate(' + (angle + 90) + 'deg)';
  }

  function layoutDecor() {
    if (!inner || !decor) return;
    decor.style.height = inner.scrollHeight + 'px';
    buildPath();
    updateFlight();
  }

  if (inner && decor) {
    inner.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateFlight);
    }, { passive: true });
    window.addEventListener('resize', layoutDecor);
  }

  if (openBtn && modal) {
    openBtn.addEventListener('click', function () {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }

      // Reveal modal content immediately with stagger (more reliable than
      // observing inside a freshly-opened dialog, esp. in the theme editor)
      var modalTargets = modal.querySelectorAll('.fade-in-up');
      modalTargets.forEach(function (el, index) {
        setTimeout(function () {
          el.classList.add('is-visible');
        }, 80 * index);
      });

      // Size the flight-path layer once content is laid out
      setTimeout(layoutDecor, 100);
      setTimeout(layoutDecor, 600);
    });
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener('click', function () {
      modal.close ? modal.close() : modal.removeAttribute('open');
    });
  }

  if (modal && !modal.dataset.storyBackdropInit) {
    modal.dataset.storyBackdropInit = 'true';
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.close ? modal.close() : modal.removeAttribute('open');
      }
    });
  }

  function observeFadeIns(targets) {
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.section-our-story').forEach(initOurStory);
});

document.addEventListener('shopify:section:load', function (event) {
  var root = event.target.querySelector('.section-our-story');
  if (root) initOurStory(root);
});